import { render } from "./CartColumn.vue?vue&type=template&id=5ecd8d8d&scoped=true"
import script from "./CartColumn.vue?vue&type=script&lang=js"
export * from "./CartColumn.vue?vue&type=script&lang=js"

import "./CartColumn.vue?vue&type=style&index=0&id=5ecd8d8d&scoped=true&lang=scss"

import exportComponent from "/home/scotty/git/beamy/monolith/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ecd8d8d"]])

export default __exports__